/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PinnedArtifactsResponse {
    getFixupPrototypeFunction() { return PinnedArtifactsResponse.fixupPrototype; }

    static newInstance(model: Partial<PinnedArtifactsResponse>): PinnedArtifactsResponse {
        let obj = Object.assign(new PinnedArtifactsResponse(), model);
        PinnedArtifactsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PinnedArtifactsResponse>): PinnedArtifactsResponse {
        if (!model) return null;
        return PinnedArtifactsResponse.newInstance(<PinnedArtifactsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PinnedArtifactsResponse) {
        if (!obj) return;

        models.PinnedArtifactsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PinnedArtifactsResponse): boolean {
        Object.setPrototypeOf(obj, PinnedArtifactsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.artifacts) {
            for (let val of this.artifacts) {
                models.Artifact.fixupPrototype(val);
            }
        }
    }

    /**
     * Pinned artifacts for this agent
     */
    artifacts: Array<models.Artifact>;

}
